import { useState } from "react";
import { CatalogContext, CatalogInitialValues, CatalogViews, isCatalogView } from "./context";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { LocalStorage } from "src/services/LocalStorage";

type Props = {
    children: ReactNode;
    groupId: string | undefined;
    actionId: string | undefined;
};
export const CatalogProvider = (props: Props) => {
    const { groupId, actionId } = props;
    const { actionsByParents, areActionsReady } = useActionsContext();

    const _initialHide = LocalStorage.getItem("hideEngagedActions");
    const initialHide = _initialHide === "true" ? true : false;
    const [hideAddedActions, _setHideAddedActions] = useState(initialHide);
    const setHideAddedActions = (v: boolean) => {
        LocalStorage.setItem("hideEngagedActions", String(v));
        _setHideAddedActions(v);
    };

    const _initialView = LocalStorage.getItem("catalogView");
    const initialView = isCatalogView(_initialView) ? _initialView : "list";
    const [catalogView, _setCatalogView] = useState<CatalogViews>(initialView);
    const setCatalogView = (v: CatalogViews) => {
        LocalStorage.setItem("catalogView", v);
        _setCatalogView(v);
    };

    const currentCatalog = actionsByParents.catalogList.find((i) => i.parent.id.toString() === groupId);

    const _currentAction = currentCatalog?.subgroups.flatMap((subgroup) => {
        const actionItemFound = subgroup.items.find((actionItem) => actionItem.id.toString() === actionId);
        if (actionItemFound === undefined) return [];
        return actionItemFound;
    });
    // Only keeping first occurence since I'm only looking for one anyway, and it's flatMap that returns a list;
    const currentAction = _currentAction === undefined || _currentAction.length === 0 ? undefined : _currentAction[0];

    const isCatalogEmpty = actionsByParents.catalogList.length === 0 && areActionsReady;

    const items: CatalogInitialValues = {
        actionsByParents,
        areActionsReady,
        isCatalogEmpty,

        currentCatalog,
        currentAction,

        hideAddedActions,
        setHideAddedActions,

        catalogView,
        setCatalogView,
    };
    return <CatalogContext.Provider value={items}>{props.children}</CatalogContext.Provider>;
};
